import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGiftVoucherMutationVariables = GraphQLTypes.Exact<{
  code: GraphQLTypes.Scalars['String'];
  amount?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Float']>;
}>;


export type UpdateGiftVoucherMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updateGiftCard'>
);


export const UpdateGiftVoucherDocument = /*#__PURE__*/ gql`
    mutation updateGiftVoucher($code: String!, $amount: Float) {
  updateGiftCard(code: $code, amount: $amount)
}
    `;

/**
 * __useUpdateGiftVoucherMutation__
 *
 * To run a mutation, you first call `useUpdateGiftVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftVoucherMutation, { data, loading, error }] = useUpdateGiftVoucherMutation({
 *   variables: {
 *      code: // value for 'code'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useUpdateGiftVoucherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGiftVoucherMutationResult, UpdateGiftVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGiftVoucherMutationResult, UpdateGiftVoucherMutationVariables>(UpdateGiftVoucherDocument, options);
      }
export type UpdateGiftVoucherMutationHookResult = ReturnType<typeof useUpdateGiftVoucherMutation>;